<!--
 * @Author: linhao hao.lin@biz-united.com.cn
 * @Date: 2026-01-15 11:24:49
 * @LastEditors: linhao hao.lin@biz-united.com.cn
 * @LastEditTime: 2026-07-22 15:39:01
 * @FilePath: \crm-product\found\views\mdm\views\customer_information\components\extended_info\product.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div>
    <div class="terminalInfo-supplys-btn-group">
      <!-- <span v-if="!disabled" class="terminalInfo-supplys-btn"
        ><el-button icon="el-icon-plus" type="text" @click="() => openModal('Shopping')"
          >添加商品</el-button
        ></span
      > -->
      <span v-if="!disabled" class="terminalInfo-supplys-btn" style="margin-left: 10px"
        ><el-button icon="el-icon-plus" type="text" @click="() => openModal()"
          >添加产品系列</el-button
        ></span
      >
      <TableList
        :disabled="disabled"
        @deleteItem="rowIndex => deleteItem(rowIndex)"
        style="margin-top: 10px"
        :data="details"
      />
    </div>
    <Modal
      :modalConfig="{ visible: dialogVisible, title: '选择产品系列',showFooter: true, buttons: {
        sure: true,
        close: true,
      }}"
      @onOk="submitData"
      @onClose="closeModal"
    >
      <ProductLevel :selectKeys="selectKeys" @onSelect="value => onSelect(value)" />
      <!-- <div slot="footer">
        <el-button type="primary" @click="() => submitData()">确定</el-button>
        <el-button @click="() => closeModal()">取消</el-button>
      </div> -->
    </Modal>
  </div>
</template>

<script>
// import Shopping from './shopping/shopping.vue';
import TableList from './table/table.vue';
import ProductLevel from './productLevel/productLevel.vue';
import Modal from '../../../../../../components/modal/components/modal.vue';

export default {
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    value: Array,
  },
  components: {
    // Shopping,
    TableList,
    ProductLevel,
    Modal,
  },
  watch: {
    value: {
      deep: true,
      immediate: true,
      handler(v) {
        this.details = v || [];
        if (v) {
          // v.map((a) => {
          //   const resData = a;
          //   resData.productCode = resData.code;
          //   return resData;
          // });
          this.selectKeys = v;
        }
      },
    },
  },
  data() {
    return {
      details: [],
      dialogVisible: false,
      selectItem: [],
      selectKeys: [],
    };
  },
  methods: {
    openModal() {
      this.dialogVisible = true;
    },
    onSelect(value) {
      this.selectItem = value;
    },
    deleteItem(rowIndex) {
      this.details.splice(rowIndex, 1);
    },
    resetArr(arr, key) {
      const result = [];
      const obj = {};
      for (let i = 0; i < arr.length; i += 1) {
        if (!obj[arr[i][key]]) {
          result.push(arr[i]);
          obj[arr[i][key]] = true;
        }
      }
      return result;
    },
    submitData() {
      let _selectItem = this.selectItem;
      // console.log(selectItem);
      _selectItem = _selectItem.map((item) => ({
        seriesName: item.productLevelName,
        seriesCode: item.productLevelCode,
        // ...item,
        // dataType: '2',
      }));
      // const { formName } = this;
      // if (formName === 'Shopping') {
      //   selectItem = selectItem.map((item) => ({
      //     ...item,
      //     code: item.productCode,
      //     name: item.productName,
      //     dataType: '1',
      //   }));
      // } else {
      //   selectItem = selectItem.map((item) => ({
      //     ...item,
      //     dataType: '2',
      //   }));
      // }
      this.dialogVisible = false;
      // const isShopping = this.details.filter((item) => item.dataType === '1');
      // if (isShopping.length > 0 && formName === 'Shopping') {
      //   this.details = this.resetArr(this.details.concat(selectItem), 'id');
      // } else {
      //   this.details = selectItem;
      // }
      this.details = _selectItem;
      this.$emit('input', this.details);
    },
    closeModal() {
      this.dialogVisible = false;
    },
  },
};
</script>
